export function getSiteUrl(): string {
  const env = (import.meta as any)?.env?.VITE_SITE_URL as string | undefined;
  if (env && typeof env === "string" && env.trim()) return env.replace(/\/+$/, "");
  if (typeof window !== "undefined" && window.location?.origin) return window.location.origin;
  return "https://halomora.com";
}

